// src/components/WhatsAppFloatingButton.jsx
import { MessageCircle } from 'lucide-react';
import { NavLink } from 'react-router-dom';

const WhatsAppFloatingButton = () => {
  return (
    <>
      <style>{`
      .whatsapp-floating-btn-wrapper {
        position: fixed;
        bottom: 20px;
        right: 20px;
        z-index: 9999;
      }

      .whatsapp-floating-btn {
        background-color: #25D366;
        color: white;
        border-radius: 20px;
        padding: 9px 15px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
        transition: transform 0.3s ease;
        position: relative;
        text-decoration: none;
        display: inline-flex;
        align-items: center;
        justify-content: center;
      }

      .whatsapp-floating-btn::after {
        content: 'Contact us';
        position: absolute;
        top: 25%;
        right: 110%;
        background-color: #000;
        color: #fff;
        padding: 5px 10px;
        font-size: 12px;
        border-radius: 4px;
        white-space: nowrap;
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.2s ease-in-out;
        margin-bottom: 6px;
        transform: rotate(360deg)
      }

      .whatsapp-floating-btn:hover::after {
        opacity: 1;

      }

      @media (max-width: 778px) {
        .whatsapp-floating-btn {
          padding: 7px 12px;
        }
          .whatsapp-floating-btn::after{
          display:none;
          }
      }
      `}</style>

      <div className="whatsapp-floating-btn-wrapper">
        <NavLink
          to="https://api.whatsapp.com/send?phone=923459403395"
          target="_blank"
          rel="noopener noreferrer"
          className="whatsapp-floating-btn"
        >
          <MessageCircle size={25} />
        </NavLink>
      </div>
    </>
  );
};

export default WhatsAppFloatingButton;
